import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-premium";
import { Box, Typography } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  title: string;
  total: number;
};

export default function AdminUsersToolbar({ title, total }: Props) {
  const { t } = useAppTranslation("common");

  return (
    <GridToolbarContainer sx={{ px: 2, py: 1.5 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>

        <Typography variant="caption" color="text.secondary">
          {total} {t("użytkowników")}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </Box>
    </GridToolbarContainer>
  );
}